"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../../Services"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Bubble5 = props => /*#__PURE__*/_react.default.createElement("div", {
  className: "sl-bubble5"
}, /*#__PURE__*/_react.default.createElement("div", {
  className: "sl-loader",
  style: {
    "--size": _Services.default.getZoom(props.size || 100)
  }
}, [...Array(4).keys()].map(item => /*#__PURE__*/_react.default.createElement("div", {
  className: "sl-loader-item",
  key: item,
  style: {
    "--bg": props.bgColor || "#FFFFFF"
  }
}))), props.title !== undefined ? /*#__PURE__*/_react.default.createElement("div", {
  className: "sl-loader-title",
  style: {
    "--cl": props.color || "#FFFFFF"
  }
}, /*#__PURE__*/_react.default.createElement("span", null, props.title)) : null);

var _default = Bubble5;
exports.default = _default;